import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    justifyContent: 'space-between',
    gap: '20px',
    width: '100%',
    alignItems: {
      md: 'center',
    },
    padding: {
      xs: '20px 24px',
      md: '48px 0px',
    },
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'unset',
    },
    flexWrap: 'wrap',
    gap: {
      xs: '16px',
      md: '24px',
    },
    flexBasis: { xs: '100%', md: '80%' },
  },
  actionButton: {
    alignSelf: 'center',
    mt: { xs: '20px', md: '32px' },
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
